import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=69c58b22&scoped=true&"
var script = {}
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=69c58b22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c58b22",
  null
  
)

export default component.exports